import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import Logo from "../../images/block-i-white-background.png"
import { Content, MainContent, UIUCContent, LogoImage } from "./Header.styles"
import Navigation from "../Navigation/Navigation"
import { Button } from "../Button/Button"
import search from "../../images/icon-search.png"

const Header = ({ navMenuData, employeePage }) => {
  const data = navMenuData
  const wpMenu = data.mainMenu
  const site = data.site
  const menu = wpMenu.menuItems.nodes

  const NavContent = styled.div`
    height: 50px;
    width: 100%;
    margin: 0 auto;

    background: var(--darkGrey);

    button {
      background: var(--darkGrey);
    }

    @media (max-width: 991px) {
      display: none;
    }
  `

  const Wrapper = styled.header`
    border-top: 7px solid var(--illiniOrange);
    width: 100%;
    z-index: 10000;
  `

  return (
    <Wrapper employeePage={employeePage}>
      <UIUCContent employeePage={employeePage}>
        <a href="https://illinois.edu/">
          <p>University of Illinois Urbana-Champaign</p>
        </a>
      </UIUCContent>
      <MainContent employeePage={employeePage}>
        <Content employeePage={employeePage}>
          <div>
            <a href="https://illinois.edu/">
              <LogoImage src={Logo} alt={site.siteMetadata.title} />
            </a>
            {employeePage ? (
              <Link to="/Employee/Home">
                <p className="unitTitleLarge">
                  F&S Employee Resources Information & News
                </p>
              </Link>
            ) : (
              <Link to="/">
                <p className="unitTitleLarge">Facilities & Services</p>
              </Link>
            )}
          </div>
          <div className="center">
            <Button
              label="Car Pool Request"
              buttonStyle="btn--blue"
              buttonSize="btn--large"
              font="primaryLink"
              externalLink="https://my2.fs.illinois.edu/app/#/car-pool/request"
            ></Button>
            <Button
              label="Request a Service"
              buttonStyle="btn--blue"
              buttonSize="btn--large"
              font="primaryLink"
              externalLink="https://my.fs.illinois.edu/fsportal/portal/service-request"
            ></Button>
            <Button
              label="Search"
              buttonStyle="btn--grey"
              buttonSize="btn--large"
              font="secondaryLink"
              link="/Search"
              icon={search}
            ></Button>
          </div>
        </Content>
      </MainContent>
      <NavContent employeePage={employeePage}>
        <Navigation menu={menu} employeePage={employeePage} />
      </NavContent>
    </Wrapper>
  )
}

export default Header
